const updateStyles = () => {
  const pageHeight = document.body.scrollHeight // Hauteur totale du document
  const sidebar = document.querySelector('.sidebar')

  if (sidebar) {
    if (pageHeight <= 631) {
      // document.body.style.background = "red"
      sidebar.style.height = "1550px"
    } else if (pageHeight > 631 && pageHeight <= 1527) {
      // document.body.style.background = "pink"
      sidebar.style.height = "1560px"
    } else if (pageHeight > 1527 && pageHeight <= 2743) {
      // document.body.style.background = "blue"
      sidebar.style.height = "2800px"
    } else {
      // document.body.style.background = "gold"
      sidebar.style.height = "5230px"
    }
  }
}

// Exécuter au chargement et à chaque changement de hauteur
window.addEventListener("resize", updateStyles)
window.addEventListener("scroll", updateStyles)
updateStyles()

export default updateStyles
